import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { VisitorStatusType } from '@/api';
import { statusFilterOptions, statusLabel } from '../../../visitorStatus';

const SystemStatusField = forwardRef((props, ref) => {
  const { data: initial } = props;
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    fillValue: data => {
      data.status = data.status || [];
      data.status['status'] = inputRef.current.value;
      return true;
    },
  }));

  return (
    <TextField
      select
      name={'status'}
      label={'Статус'}
      inputRef={inputRef}
      fullWidth
      margin='dense'
      variant='outlined'
      autoComplete='off'
      defaultValue={(initial.status && initial.status['status']) || VisitorStatusType.Initial}
    >
      {statusFilterOptions.map(s => (
        <MenuItem key={s} value={s}>
          {statusLabel(s)}
        </MenuItem>
      ))}
    </TextField>
  );
});

export default SystemStatusField;
